import React, { useState, useEffect } from 'react';


import ProductGrid from './components/ProductGrid';
import GroupedCart from './components/GroupedCart';

import products from './products.json';

const branches = { "1": "The Missing Burro", "2": "Dos Burros" }
const RestaurantOrderingApp = () => {
  const [cart, setCart] = useState([]);
  const [branch, setBranch] = useState('1');
  const [language, setLanguage] = useState('en');
  const [cartLanguage, setCartLanguage] = useState('en');
  const [searchTerm, setSearchTerm] = useState('');
  const [orderText, setOrderText] = useState('');
  const [isClipboardAvailable, setIsClipboardAvailable] = useState(false);

  useEffect(() => {
    setIsClipboardAvailable('clipboard' in navigator);
  }, []);

  const addToCart = (product) => {
    const existingItem = cart.find(item => item.id === product.id);
    if (existingItem) {
      setCart(cart.map(item =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

  const updateQuantity = (productId, newQuantity) => {
    setCart(cart.map(item =>
      item.id === productId ? { ...item, quantity: Math.max(1, newQuantity) } : item
    ));
  };

  const clearCart = () => {
    setCart([])
  }

  const clearSearch = () => {
    setSearchTerm('');
  };

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.thaiName.includes(searchTerm) ||
    product.myanmarName.includes(searchTerm) ||
    product.provider.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getProductName = (product, lang) => {
    switch (lang) {
      case 'th': return product.thaiName || product.name;
      case 'my': return product.myanmarName || product.name;
      default: return product.name;
    }
  };

  const groupedCart = cart.reduce((acc, item) => {
    if (!acc[item.provider]) {
      acc[item.provider] = [];
    }
    acc[item.provider].push(item);
    return acc;
  }, {});

  const generateOrderMessage = () => {
    const header = `Order for: ${branches[branch]}\n\n`;
    let orderDetails = '';

    Object.entries(groupedCart).forEach(([provider, items]) => {
      orderDetails += `${provider}:\n`;
      items.forEach(item => {
        orderDetails += `- ${getProductName(item, cartLanguage)} x${item.quantity}\n`;
      });
      orderDetails += '\n';
    });

    const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0).toFixed(2);
    return `${header}${orderDetails}Total: $${total}`;
  };

  const handleOrderGeneration = () => {
    const orderMessage = generateOrderMessage();
    setOrderText(orderMessage);
    if (isClipboardAvailable) {
      navigator.clipboard.writeText(orderMessage)
        .then(() => alert('Order copied to clipboard!'))
        .catch(() => alert('Failed to copy order. Please try again.'));
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Restaurant Ordering App</h1>

      <div style={{ marginBottom: '20px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ flexGrow: 1, padding: '5px', minWidth: '200px' }}
        />
        <button onClick={clearSearch} style={{ padding: '5px 10px', background: '#f44336', color: 'white', border: 'none', cursor: 'pointer' }}>
          Clear
        </button>
        <select value={branch} onChange={(e) => setBranch(e.target.value)} style={{ padding: '5px' }}>
          <option value="1">The Missing Burro</option>
          <option value="2">Dos Burros</option>
        </select>
        <select value={language} onChange={(e) => setLanguage(e.target.value)} style={{ padding: '5px' }}>
          <option value="en">English</option>
          <option value="th">Thai</option>
          <option value="my">Myanmar</option>
        </select>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: 'semibold', marginBottom: '10px' }}>Products</h2>
          <div style={{ overflowX: 'auto' }}>


            <ProductGrid
              filteredProducts={filteredProducts}
              language={language}
              getProductName={getProductName}
              addToCart={addToCart}
            />

          </div>
        </div>

        <div>
          <h2 style={{ fontSize: '20px', fontWeight: 'semibold', marginBottom: '10px' }}>Cart</h2>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ marginRight: '10px' }}>Cart Language:</label>
            <select value={cartLanguage} onChange={(e) => setCartLanguage(e.target.value)} style={{ padding: '5px' }}>
              <option value="en">English</option>
              <option value="th">Thai</option>
              <option value="my">Myanmar</option>
            </select>
            <button onClick={clearCart} className="delbutton">
              Clear
            </button>
          </div>
<div>

          <GroupedCart
            groupedCart={groupedCart}
            language={cartLanguage}
            getProductName={getProductName}
            updateQuantity={updateQuantity}
            removeFromCart={removeFromCart}
            />
            </div>

          <div style={{ marginTop: '20px' }}>
            <button onClick={handleOrderGeneration} style={{ width: '100%', padding: '10px', background: '#008CBA', color: 'white', border: 'none', cursor: 'pointer' }}>
              {isClipboardAvailable ? 'Copy Order to Clipboard' : 'Generate Order'}
            </button>
          </div>
          {!isClipboardAvailable && (
            <textarea
              value={orderText}
              readOnly
              style={{ width: '100%', height: '100px', marginTop: '10px', padding: '5px' }}
              placeholder="Generated order will appear here"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RestaurantOrderingApp;
